import { gql } from "@apollo/client";

export const ProfileCareerTabRoleFragment = gql`
  fragment ProfileCareerTabCompetency on CompetencyNode {
    id
    title
    criteria {
      edges {
        node {
          id
          content
        }
      }
    }
  }
  fragment ProfileCareerTabResponsibility on CareerTrackRoleResponsibilityNode {
    id
    content
  }
  fragment ProfileCareerTabRole on CareerTrackRoleNode {
    id
    title
    level
    roleType
    competencies {
      edges {
        node {
          ...ProfileCareerTabCompetency
        }
      }
    }
    responsibilities {
      edges {
        node {
          ...ProfileCareerTabResponsibility
        }
      }
    }
  }
`;

export const ProfileCareerTabCareerTrackFragment = gql`
  ${ProfileCareerTabRoleFragment}
  fragment ProfileCareerTabCareerTrack on CareerTrackNode {
    id
    title
    roles {
      edges {
        node {
          ...ProfileCareerTabRole
        }
      }
    }
  }
`;

export default gql`
  ${ProfileCareerTabCareerTrackFragment}
  query getProfileCareerQuery($userId: Int!, $organizationId: Int!) {
    user(userId: $userId) {
      id
      name
      firstName
      isInCurrentUserReportingTree
      email
      avatar
      timezone
      email
      lastSeenStr
      managersList {
        id
        name
        avatar
      }
      currentRoles {
        id
        careerTrack {
          ...ProfileCareerTabCareerTrack
        }
      }
    }
    canEditUserCareerCriteria(organizationId: $organizationId, userId: $userId)
  }
`;
